"use client";
import SvgFavoriteFilled from "./favorite-filled.svg.js";
import SvgFavoriteOutlined from "./favorite-outlined.svg.js";
import SvgFavoriteRound from "./favorite-round.svg.js";
import SvgFavoriteSharp from "./favorite-sharp.svg.js";
import SvgFavoriteBorderFilled from "./favorite_border-filled.svg.js";
import SvgFavoriteBorderOutlined from "./favorite_border-outlined.svg.js";
import SvgFavoriteBorderRound from "./favorite_border-round.svg.js";
import SvgFavoriteBorderSharp from "./favorite_border-sharp.svg.js";
import SvgStarFilled from "./star-filled.svg.js";
import SvgStarOutlined from "./star-outlined.svg.js";
import SvgStarRound from "./star-round.svg.js";
import SvgStarSharp from "./star-sharp.svg.js";
import SvgStarOutlineFilled from "./star_outline-filled.svg.js";
import SvgStarOutlineOutlined from "./star_outline-outlined.svg.js";
import SvgStarOutlineRound from "./star_outline-round.svg.js";
import SvgStarOutlineSharp from "./star_outline-sharp.svg.js";
const favorite = {
  filled: SvgFavoriteFilled,
  outlined: SvgFavoriteOutlined,
  round: SvgFavoriteRound,
  sharp: SvgFavoriteSharp
};
const favorite_border = {
  filled: SvgFavoriteBorderFilled,
  outlined: SvgFavoriteBorderOutlined,
  round: SvgFavoriteBorderRound,
  sharp: SvgFavoriteBorderSharp
};
const star = {
  filled: SvgStarFilled,
  outlined: SvgStarOutlined,
  round: SvgStarRound,
  sharp: SvgStarSharp
};
const star_outline = {
  filled: SvgStarOutlineFilled,
  outlined: SvgStarOutlineOutlined,
  round: SvgStarOutlineRound,
  sharp: SvgStarOutlineSharp
};
export {
  favorite,
  favorite_border,
  star,
  star_outline
};
